import type { ReactNode } from 'react';
import React from 'react';
import ChevronDown from '@uber/base-icons/chevron-down';
import ChevronUp from '@uber/base-icons/chevron-up';
import { styled } from 'baseui';
import { EXPAND_COLLAPSE_ICON_SIZE } from '../constant/constant';
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  border: `0px solid`
}));
type PropsT = {
  expanded: boolean;
  trailingComponent?: ReactNode;
};
export const ToggleContainer = ({
  expanded,
  trailingComponent
}: PropsT) => {
  return <Container>
      {trailingComponent}
      {expanded ? <ChevronDown title="Collapse" size={EXPAND_COLLAPSE_ICON_SIZE} /> : <ChevronUp title="Expand" size={EXPAND_COLLAPSE_ICON_SIZE} />}
    </Container>;
};